import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_ZONE](state, payload) {
    state.zone = payload;
  },
  [MutationsType.SET_ZONES](state, payload) {
    state.zones = payload;
  },
  [MutationsType.ADD_ZONE](state, payload) {
    if (state.zones) state.zones.unshift(payload);
  },
  [MutationsType.UPDATE_ZONE](state, payload) {
    let ind = (state.zones || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.zones, ind, payload);
  },
  [MutationsType.DELETE_ZONE](state, payload) {
    let ind = (state.zones || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.zones, ind);
  },
};
